/* Sonelie cart drawer (UpCart-style, built in the theme, no app):
   1) delivery countdown in the drawer, same rule as the product page block (16:00 cut-off, 9 weekdays, fr-FR)
   2) gift sync, PER PRODUCT: the free gifts of each Kaching deal follow how many of that product are in the cart.
      Missing gifts are added with Kaching's own tag (Kaching's discount then makes them 0 EUR); gifts no longer
      earned are removed so nobody pays for a "free" gift. Add a product here when its Kaching deal has gifts.
      MAP[handle][paid quantity] = [[gift product id, Kaching gift id, gift quantity], ...] */
(function () {
  var CFG = window.SL_CART || {};
  var MAP = CFG.map || {
    'premiere-brassiere': {
      2: [[9337134743690, 'AaWs', 1]],
      4: [[9337134743690, 'vuM2', 1], [9337134940298, '_3VK', 1]],
      6: [[9304238456970, 'qI7q', 1], [9337134743690, '54xT', 1], [9337134940298, 'MnB_', 1]]
    },
    'paperflight-kit-avion-papier-rc': {
      3: [[9377922351242, 'uWhv', 1]],
      5: [[9377922351242, 'lwtP', 3]]
    },
    'blockblaster-diy-ops-handle-set': {
      3: [[9377922875530, 'aKya', 1]],
      5: [[9377922875530, 'mcpF', 1], [9377922875530, 'xB0v', 1], [9377922875530, 'Rjty', 1]]
    },
    'mascara-serum-pour-cils': {
      4: [[9397756854410, 'YbFF', 1]]
    }
  };
  var HANDLES = { 9304238456970: 'brassiere-coton', 9337134743690: 'guide-parents-premiere-brassiere',
                  9337134940298: 'un-mot-pour-elle-cartes', 9377922351242: 'paperflight-kit-avion-papier-rc', 9377922875530: 'blockblaster-diy-ops-handle-set',
                  9397756854410: 'serum-pour-cils-offert' };

  /* ---------- 1) delivery countdown ---------- */
  function eta() {
    document.querySelectorAll('[data-sl-eta]').forEach(function (el) {
      var cut = parseInt(el.dataset.cutoff, 10) || 16, days = parseInt(el.dataset.days, 10) || 9;
      var now = new Date(), end = new Date(); end.setHours(cut, 0, 0, 0);
      if (now > end) end.setDate(end.getDate() + 1);
      var ms = end - now, h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
      var max = parseInt(el.dataset.daysMax, 10) || 0;
      function wd(k) {
        var d = new Date(), n = 0;
        while (n < k) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n++; }
        return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      }
      var date = wd(days), date2 = max ? wd(max) : '';
      var t = el.querySelector('[data-sl-eta-text]');
      if (t && t.dataset.tpl == null) t.dataset.tpl = t.textContent;
      var txt = t ? t.dataset.tpl.replace('[timer]', h + ' h ' + m + ' min').replace('[date2]', date2).replace('[date]', date) : '';
      if (t && t.textContent !== txt) t.textContent = txt;
    });
  }
  // per-product total pill (sl-cart-extras 'total'): the drawer is re-rendered with innerHTML (no scripts run), so place it from here
  function pill() {
    var t = document.getElementById('sl-cx-total'), v = document.querySelectorAll('cart-drawer .totals .totals__total-value'); v = v[v.length - 1];
    if (t && v && !v.parentNode.querySelector('.sl-cx-pill')) v.insertAdjacentHTML('beforebegin', t.innerHTML);
    var lb = document.getElementById('sl-cx-label'), tt = document.querySelectorAll('cart-drawer .totals .totals__total'); tt = tt[tt.length - 1];   // per-product total label ('Sous-total')
    if (lb && tt && tt.textContent !== lb.innerHTML.trim()) tt.textContent = lb.innerHTML.trim();
  }
  // cheap: only touches the text when it changes; runs every 2 s so a freshly rendered drawer is filled at once
  setInterval(function () { eta(); pill(); }, 700);
  document.addEventListener('DOMContentLoaded', eta);

  // 'Switch to subscription' box on a one-time line (sl-cart-extras line_up): same line on the plan + the plan's free gifts
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sl-cx-upgrade]'); if (!b) return; e.preventDefault(); b.disabled = true;
    var gifts = (b.dataset.gifts || '').split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
    // remove the one-time line, then add gifts + the same product on the plan in one call (main product last = shown on top, like the bundle widget)
    var items = gifts.concat([{ id: +b.dataset.variant, quantity: +b.dataset.qty, selling_plan: +b.dataset.plan }]);
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.slCxUpgrade, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function () { return fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble'); }).then(function (r) { return r.json(); })
      .then(function (sec) { var d = document.querySelector('cart-drawer'); if (d && d.renderContents) d.renderContents({ sections: sec }); })
      .catch(function () { location.href = '/cart'; });
  });

  /* ---------- 2) gift sync ---------- */
  var busy = false, timer = null, ours = false;
  function giftOf(item) {
    var p = item.properties && item.properties.__kaching_bundles;
    if (!p || p.indexOf('"gift"') < 0) return null;
    try { return JSON.parse(p); } catch (e) { return null; }
  }
  function post(url, body) {
    ours = true;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .finally(function () { ours = false; });
  }
  async function variantFor(pid, mainLines, cart) {
    var same = mainLines.find(function (i) { return i.product_id == pid; });   // gift = the product itself: same colour/size
    if (same) return same.variant_id;
    var known = cart.items.find(function (i) { return i.product_id == pid; });
    if (known) return known.variant_id;
    if (!HANDLES[pid]) return null;
    var p = await (await fetch('/products/' + HANDLES[pid] + '.js')).json();
    var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
    return v && v.id;
  }
  async function sync() {
    if (busy) return; busy = true;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var changed = false, want = {}, need = [];
      // 0 EUR gift products (e-books, mystery gift) are never bought alone: no paid line left in the cart = remove them
      // (gift = a 0 EUR product, or a 'Cadeau'/'Numérique' product the 'Cadeau offert' discount makes free)
      var isGift = function (i) { return !giftOf(i) && (i.original_price === 0 || i.product_type === 'Cadeau' || i.product_type === 'Numérique'); };
      var paidLines = cart.items.filter(function (i) { return !isGift(i) && i.original_price > 0 && i.product_type !== 'Protection'; });
      // SL 16 Oct: a paid drawer add-on ('Protection' product, e.g. Protection de livraison 3,99 €) is never left alone in the cart
      if (!paidLines.length) for (var z0 = 0; z0 < cart.items.length; z0++) if (cart.items[z0].product_type === 'Protection') { await post('/cart/change.js', { id: cart.items[z0].key, quantity: 0 }); changed = true; }
      if (!paidLines.length) for (var z = 0; z < cart.items.length; z++) if (isGift(cart.items[z])) { await post('/cart/change.js', { id: cart.items[z].key, quantity: 0 }); changed = true; }
      // a priced gift ('Cadeau offert' discount) that is NOT free right now (another product's bundle discount blocked it): never charge it, remove it
      else for (var z2 = 0; z2 < cart.items.length; z2++) { var gi2 = cart.items[z2]; if (isGift(gi2) && gi2.original_price > 0 && gi2.final_line_price > 0) { await post('/cart/change.js', { id: gi2.key, quantity: 0 }); changed = true; } }
      // what each product in the cart has earned
      Object.keys(MAP).forEach(function (h) {
        var lines = cart.items.filter(function (i) { return i.handle === h && !giftOf(i); });
        var n = lines.reduce(function (a, i) { return a + i.quantity; }, 0);
        var tiers = Object.keys(MAP[h]).map(Number).filter(function (t) { return t <= n; });
        if (!n || !tiers.length) return;
        var mp = null;
        for (var k = 0; k < lines.length && !mp; k++) { try { mp = JSON.parse(lines[k].properties.__kaching_bundles); } catch (e) {} }
        if (!mp) return;
        MAP[h][Math.max.apply(null, tiers)].forEach(function (g) {
          want[g[1]] = g[2];
          need.push({ pid: g[0], gid: g[1], q: g[2], mp: mp, lines: lines });
        });
      });
      // remove gifts no longer earned, fix quantities of earned ones
      var seen = {};
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i], g = giftOf(it);
        if (!g) continue;
        var known = Object.keys(MAP).some(function (h) { return Object.keys(MAP[h]).some(function (t) { return MAP[h][t].some(function (x) { return x[1] === g.gift; }); }); });
        if (!known) continue;                                   // a gift from a deal we don't manage: leave it
        if (!want[g.gift] || seen[g.gift]) { await post('/cart/change.js', { id: it.key, quantity: 0 }); changed = true; continue; }
        seen[g.gift] = true;
        if (it.quantity !== want[g.gift]) { await post('/cart/change.js', { id: it.key, quantity: want[g.gift] }); changed = true; }
      }
      // add earned gifts that are missing (with Kaching's tag from the paid line)
      for (var j = 0; j < need.length; j++) {
        var n2 = need[j];
        if (seen[n2.gid]) continue;
        var vid = await variantFor(n2.pid, n2.lines, cart);
        if (!vid) continue;
        var prop = JSON.stringify({ id: n2.mp.id, deal: n2.mp.deal, v: n2.mp.v, gift: n2.gid });
        await post('/cart/add.js', { items: [{ id: vid, quantity: n2.q, properties: { __kaching_bundles: prop } }] });
        changed = true;
      }
      // SL bundle widget: free units carry _slb_gift = "paid:free,paid:free" (the deal's gift rules).
      // If paid units drop below what earns the free units, remove/trim them (nobody pays for a "free" unit);
      // if more paid units earn more free ones and a free line exists, top it up.
      var slb = {};
      cart.items.forEach(function (it) {
        var g = it.properties && it.properties._slb_gift, k = it.product_id;
        slb[k] = slb[k] || { paid: 0, gifts: [], rules: null };
        if (g) { slb[k].gifts.push(it); slb[k].rules = String(g); } else slb[k].paid += it.quantity;
      });
      for (var pk in slb) {
        var S = slb[pk]; if (!S.rules) continue;
        var want = 0; S.rules.split(',').forEach(function (r) { var p = r.split(':'); if (S.paid >= +p[0]) want = Math.max(want, +p[1]); });
        var have = S.gifts.reduce(function (a, it) { return a + it.quantity; }, 0);
        if (have > want) {
          var cut = have - want;
          for (var gi = S.gifts.length - 1; gi >= 0 && cut > 0; gi--) { var it2 = S.gifts[gi], nq = Math.max(0, it2.quantity - cut); cut -= it2.quantity - nq; await post('/cart/change.js', { id: it2.key, quantity: nq }); changed = true; }
        } else if (have < want && S.gifts.length) {
          await post('/cart/change.js', { id: S.gifts[0].key, quantity: S.gifts[0].quantity + (want - have) }); changed = true;
        }
      }
      if (changed) {
        var drawer = document.querySelector('cart-drawer');
        var sec = await (await fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble')).json();
        if (drawer && drawer.renderContents) drawer.renderContents({ sections: sec });
      }
    } catch (e) { /* never break the cart */ }
    busy = false;
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 700); }
  var of = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (!ours && /\/cart\/(add|change|update|clear)/.test(url)) p.then(later, later);
    return p;
  };
  document.addEventListener('DOMContentLoaded', later);
})();
